import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'ghost' | 'quiet' | 'audit' | 'play';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly size?: 'md' | 'sm';
  readonly icon?: ReactNode;
  readonly iconAfter?: ReactNode;
}

/**
 * `audit` e a variante dos quatro botoes que sao a identidade do produto —
 * "Why do we say this?", "Why this status?", "What would change my mind?",
 * "Challenge this assessment". Azul, sempre com a mesma etiqueta no mesmo
 * sitio: sao convites a inspeccionar, nao accoes de fluxo.
 */
export function Button({
  variant = 'primary', size = 'md', icon, iconAfter, children, className, type = 'button', ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx('et-btn', `et-btn--${variant}`, size === 'sm' && 'et-btn--sm', className)}
      {...rest}
    >
      {icon}
      {children}
      {iconAfter}
    </button>
  );
}
